export enum SolidSurfaceConfigPieces {
    A = 'a',
    B = 'b',
    C = 'c',
    D = 'd',
    E = 'e',
    I = 'i'
}
